<template>
  <div class="space-y-2 py-2">
    <OptionItem
      v-if="onDelete"
      label="Delete Post"
      icon="trash"
      destructive
      @click="handleDelete" />
  </div>
</template>

<script setup>
import { nextTick } from 'vue'
import { OptionItem } from '@/components/Options'

const props = defineProps({
  post: Object,
  onDelete: Function
})

const emit = defineEmits(['close'])

const handleDelete = async () => {
  emit('close')
  await nextTick()
  if (props.onDelete) {
    props.onDelete()
  }
}
</script>
